import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut as firebaseSignOut, type User } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyC7gUmKzMZcxikl1VMl-LibogWYvAM19sg',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'elevia-cultivaton.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'elevia-cultivaton',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'elevia-cultivaton.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '872408221080',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:872408221080:web:ca633723343f3dac2117ed',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-W50KN0Y6B7'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase services
export const auth = getAuth(app);

// Initialize Firestore with persistent cache (replaces deprecated enableIndexedDbPersistence)
// This enables offline persistence with multi-tab support
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const storage = getStorage(app);

console.log('[Firebase] Initialized with persistent local cache');

// Import collections from single source of truth
import { COLLECTIONS as SHARED_COLLECTIONS, CONTROLLER_ID } from '../shared/constants';

// Re-export with users collection (shared with production for SSO)
export const COLLECTIONS = {
  ...SHARED_COLLECTIONS,
  users: 'users', // Shared with production for SSO
};

// Re-export CONTROLLER_ID for convenience
export { CONTROLLER_ID };

// Auth helpers
export const signIn = (email: string, password: string) => 
  signInWithEmailAndPassword(auth, email, password);

export const signOut = () => firebaseSignOut(auth);

export const onAuthChange = (callback: (user: User | null) => void) =>
  onAuthStateChanged(auth, callback);

export type { User };
export default app;
